module.exports = __webpack_public_path__ + "img/4.ce8c9eeb.jpg";